import {Component, OnInit} from '@angular/core';
import {
  SystemUserRole
} from "../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.model";
import {LayoutService} from "../../../shared/components/app-layout/shared-layout/layout.service";
import {ActivatedRoute} from "@angular/router";
import {NotificationService} from "../../../services/notification.service";
import {GraphqlService} from "../../../services/graphql.service";
import {concat, Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store';
import {SettingsService} from "../../../services/settings.service";
import {SystemRolesAddComponent} from "./system-roles-add/system-roles-add.component";
import {UserRole} from "../../../store/entities/user-management/user-role/user-role.model";
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {
  DELETE_USER_ROLES_MUTATION,
  GET_ROLES_QUERY
} from "../../../store/entities/user-management/user-role/user-role.graphql";
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {ActionButton} from "../../../shared/components/paginated-data-table/action-button.model";
import {TableConfiguration} from "../../../shared/components/paginated-data-table/paginated-table-configuration.model";

@Component({
  selector: 'app-system-roles-list',
  templateUrl: './system-roles-list.component.html',
  styleUrl: './system-roles-list.component.scss'
})
export class SystemRolesListComponent implements OnInit {

  loading: boolean;
  viewDetails: boolean;
  addPermission: string[] = ['can_create_role'];
  viewDetailsTitle: string;
  viewType: string;
  selectedUuid: string;
  tableColumns: object;
  searchKeys = ["name"];
  routeSub = Subscription.EMPTY;
  title: string;
  systemUserRoles$: Observable<UserRole[]>;

  constructor(
    private layoutService: LayoutService,
    private activeRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private apollo: GraphqlService,
    private settingsService: SettingsService,
  ) {
  }
query
  ngOnInit() {
    
    this.title = "Warehouses List";
    this.query = GET_ROLES_QUERY

    this.systemUserRoles$ = this.store.select(selectStoreItems(StoreItemEntity.userRole));

    this.routeSub = this.activeRoute.queryParams.subscribe(items => {
      this.title = '  ';
      this.viewDetails = !!items['action'];
      this.viewType = items['action'] ?? '';
      this.selectedUuid = items['id'] ?? '';

      this.viewDetailsTitle = this.viewType === 'view' ? 'System Role Details' : '';

    });

    

    this.title = '   ';
  }

  customAction(event: any) {
      console.log('Custom action event:', event); 
    if (event?.action == 'more') return this.onView(event?.value);
    if (event?.action == 'delete') return this.onDelete(event?.value);
    if (event?.action == 'edit') return this.onAdd(event?.value);
  }

  upsertAction = StoreItemActions.upsertStoreItem;
  removeAction = StoreItemActions.deleteStoreItem;

  refreshDataTable: boolean = false;
  permissions = {
    more: ['can_view_role'],
    edit: ['can_edit_role'],
    delete: ['can_delete_role'],
  }

  tableConfiguration: TableConfiguration = {
    tableColumns: [
      {name: 'roleName', label: 'Name'},
      // {name: 'roleDescription', label: 'Description'},
      // {name: 'capacity', label: 'Size'},
      // {name: 'buildings', label: 'Buildings'},
    ],
    tableCaption: '',
    showNumbers: true,
    tableNotifications: 'Notification',
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: 'Activate',
    empty_msg: 'No data found',
  }

  actionButtons: ActionButton[] = [
    {
      id: 'more',
      label: 'View More',
      title: 'View More',
      class: '',
      icon: 'list',
      action: 'more',
      confirm_first: false,
      loading_message: ''
    },
    {
      id: 'edit',
      label: 'Edit',
      title: 'Edit',
      class: '',
      icon: 'edit',
      action: 'edit',
      confirm_first: false,
      loading_message: ''
    },
    {
      id: 'delete',
      label: 'Delete',
      title: 'Delete',
      class: '',
      icon: 'delete',
      action: 'delete',
      confirm_first: false,
      loading_message: ''
    },
  ];


  

  onAdd(systemUserRole: SystemUserRole = null) {
    this.settingsService.openDialogModal({
      data: {
        systemUserRole
      },
      component: SystemRolesAddComponent
    })
  }

  onView(data: SystemUserRole = null) {
      console.log('Viewing role with uniqueId:', data?.uniqueId);
    this.layoutService.openPanel({action: 'view', id: data?.uniqueId});
    this.viewDetailsTitle = 'Role Permissions';
  }

  onDelete(userRole: SystemUserRole) {
    this.notificationService.confirmation({message: 'Are you sure?'}).then(
      async (data) => {
        try { 
          if (data) {
            this.store.dispatch(StoreItemActions.removeStoreItem({
              entity: StoreItemEntity.userRole,
              input: {
                uniqueId: userRole.uniqueId,
              },
              id: userRole?.id,
              mutation: DELETE_USER_ROLES_MUTATION
            }))
          }
        } catch (error) {
          console.error(error)
        }
      })
  }

  closePanel(shouldUpdate = false) {
    this.layoutService.closePanel();
  }

  protected readonly concat = concat;
}
